import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
`;

const Title = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 125%;
  text-align: center;
  letter-spacing: -0.01em;
  color: #e96159;
  width: 100%;
  padding: 16px 0px;
`;

const Selector = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  width: 150px;
  height: 85px;
  font-size: 32px;
  background: #ffffff;
  color: #e96159;
  border: 1px solid #e96159;
  cursor: pointer;
  &:hover {
    background: #e96159;
    color: #ffffff;
  }
`;

const Data = styled.div`
  height: 85px;
  font-family: "Inter";
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 125%;
  text-align: center;
  letter-spacing: -0.01em;
  color: #e96159;
  width: 100%;
  padding: 20px 0px;
  border-top: 1px solid #e96159;
  border-bottom: 1px solid #e96159;
`;

export default function NumberPicker({ title, red, callback }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (callback) {
      callback(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Wrapper>
      <Title>{title}</Title>
      <Selector>
        <Button
          style={{
            background: red ? "#e96159" : "#FFFFFF",
            color: red ? "#ffffff" : "#e96159",
          }}
          onClick={() => {
            let newValue = value - 1;
            if (newValue < 0) {
              newValue = 0;
            }
            setValue(newValue);
          }}
        >
          -
        </Button>
        <Data>{value}</Data>
        <Button
          style={{
            background: red ? "#e96159" : "#FFFFFF",
            color: red ? "#ffffff" : "#e96159",
          }}
          onClick={() => {
            let newValue = value + 1;
            setValue(newValue);
          }}
        >
          +
        </Button>
      </Selector>
    </Wrapper>
  );
}
